import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-note-modal',
    templateUrl: './note-modal.component.html',
    styleUrls: ['./note-modal.component.scss'],
    standalone: false
})
export class NoteModalComponent {
  @Input() public data: any[];
}
